import { useCallback } from 'react';
import { useAuth } from './AuthContext';

/**
 * Read-only guard hook for super_admin "soft login" (impersonation) mode.
 *
 * Wrap any write action (create/update/delete) with the returned guard:
 *   const guard = useReadOnlyGuard();
 *   const handleSubmit = () => {
 *     if (guard()) return;
 *     // ...actual write
 *   };
 *
 * Returns `true` and shows a Spanish alert when the app is in read-only
 * impersonation mode, so the caller can early-return.
 */
export function useReadOnlyGuard() {
  const { isReadOnly } = useAuth();
  return useCallback(
    (customMessage?: string): boolean => {
      if (!isReadOnly) return false;
      try {
        // eslint-disable-next-line no-alert
        alert(
          customMessage ||
            'Modo solo lectura: estás viendo esta cuenta como Super Admin. Sal del modo de suplantación para realizar cambios.'
        );
      } catch {
        // ignore (SSR / non-browser contexts)
      }
      return true;
    },
    [isReadOnly]
  );
}
